import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { AppNavigationService } from "app/layout/service/app.navigation.service";
import { AuthService } from "app/shared/auth.service";
import { DialogBaseComponent } from "app/shared/dialog-base.component";
import { DomainService } from "app/shared/domain.service";
import { NotepadPrinterDialogComponent } from "./notepad-printer-dialog.component";

@Component({
  selector: "app-notepad-layout",
  templateUrl: "./notepad-layout.component.html",
  styleUrls: ["./notepad-layout.component.scss"],
  standalone: false,
})
export class NotepadLayoutComponent implements OnInit, OnDestroy {
  userInitials = "";

  // Used by DialogBaseComponent.open as the IDialogParent.
  pngDialogService = this.domainService.pngDialogService;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private navigationService: AppNavigationService,
    private authService: AuthService,
    private domainService: DomainService
  ) {}

  ngOnInit() {
    this.navigationService.hide();
    this.document.body.classList.add("notepad-mode");
    const user = this.authService.getUser();
    this.userInitials = user?.initials || "?";
  }

  ngOnDestroy() {
    this.document.body.classList.remove("notepad-mode");
    this.navigationService.show();
  }

  logout() {
    this.authService.logout();
  }

  async openPrinterSettings() {
    await DialogBaseComponent.open(NotepadPrinterDialogComponent, this, {});
  }
}
